const detail = {
  state: {
    detail: null,
    detailSave: null,
    detailSource: null,
    detailBasic: null,
    detailChar: null,
    detailLink: null,
    detailPref: null,
    detailRelps: null,
    detailRev: null,
    detailSelect: null,
    detailStats: null,
    detailTech: null,
    detailEquip: null,
    detailPart: null,
    detailRisk: null
  },
  mutations: {
    changeDetail(state, payload) {
      state.detail = payload;
    },
    changeDetailSave(state, payload) {
      state.detailSave = payload;
    },
    changeDetailSource(state, payload) {
      state.detailSource = payload;
    },
    changeDetailBasic(state, payload) {
      state.detailBasic = payload;
    },
    changeDetailChar(state, payload) {
      state.detailChar = payload;
    },
    changeDetailLink(state, payload) {
      state.detailLink = payload;
    },
    changeDetailPref(state, payload) {
      state.detailPref = payload;
    },
    changeDetailRelps(state, payload) {
      state.detailRelps = payload;
    },
    changeDetailRev(state, payload) {
      state.detailRev = payload;
    },
    changeDetailSelect(state, payload) {
      state.detailSelect = payload;
    },
    changeDetailStats(state, payload) {
      state.detailStats = payload;
    },
    changeDetailTech(state, payload) {
      state.detailTech = payload;
    },
    changeDetailEquip(state, payload) {
      state.detailDetailEquip = payload;
    },
    changeDetailPart(state, payload) {
      state.detailPart = payload;
    },
    changeDetailRisk(state, payload) {
      state.detailRisk = payload;
    }
  },
  actions: {
    changeDetail({ commit }, payload) {
      commit("changeDetail", payload);
    },
    changeDetailSave({ commit }, payload) {
      commit("changeDetailSave", payload);
    },
    changeDetailSource({ commit }, payload) {
      commit("changeDetailSource", payload);
    },
    changeDetailBasic({ commit }, payload) {
      commit("changeDetailBasic", payload);
    },
    changeDetailChar({ commit }, payload) {
      commit("changeDetailChar", payload);
    },
    changeDetailLink({ commit }, payload) {
      commit("changeDetailLink", payload);
    },
    changeDetailPref({ commit }, payload) {
      // commit to store
      commit("changeDetailPref", payload);
    },
    changeDetailRelps({ commit }, payload) {
      // commit to store
      commit("changeDetailRelps", payload);
    },
    changeDetailRev({ commit }, payload) {
      // commit to store
      commit("changeDetailRev", payload);
    },
    changeDetailSelect({ commit }, payload) {
      commit("changeDetailSelect", payload);
    },
    changeDetailStats({ commit }, payload) {
      commit("changeDetailStats", payload);
    },
    changeDetailTech({ commit }, payload) {
      commit("changeDetailTech", payload);
    },
    changeDetailEquip({ commit }, payload) {
      commit("changeDetailEquip", payload);
    },
    changeDetailPart({ commit }, payload) {
      commit("changeDetailPart", payload);
    },
    changeDetailRisk({ commit }, payload) {
      commit("changeDetailRisk", payload);
    }
  },
  getters: {
    getDetail: state => {
      return state.detail;
    },
    getDetailSave: state => {
      return state.detailSave;
    },
    getDetailSource: state => {
      return state.detailSource;
    },
    getDetailBasic: state => {
      return state.detailBasic;
    },
    getDetailChar: state => {
      return state.detailChar;
    },
    getDetailLink: state => {
      return state.detailLink;
    },
    getDetailPref: state => {
      return state.detailPref;
    },
    getDetailRelps: state => {
      return state.detailRelps;
    },
    getDetailRev: state => {
      return state.detailRev;
    },
    getDetailSelect: state => {
      return state.detailSelect;
    },
    getDetailStats: state => {
      return state.detailStats;
    },
    getDetailTech: state => {
      return state.detailTech;
    },
    getDetailEquip: state => {
      return state.detailEquip;
    },
    getDetailPart: state => {
      return state.detailPart;
    },
    getDetailRisk: state => {
      return state.detailRisk;
    }
  }
};
// eslint-disable-next-line
export default detail;
